module.exports = __webpack_public_path__ + "img/wallet_01_fx.ed91f4cb.png";